import { render, staticRenderFns } from "./health-punch.vue?vue&type=template&id=231be777&scoped=true&"
import script from "./health-punch.vue?vue&type=script&lang=js&"
export * from "./health-punch.vue?vue&type=script&lang=js&"
import style0 from "./health-punch.vue?vue&type=style&index=0&id=231be777&scoped=true&lang=css&"
import style1 from "./health-punch.vue?vue&type=style&index=1&id=231be777&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231be777",
  null
  
)

export default component.exports